<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="k-card pa-6" elevation="6">
          <div class="text-h6 font-weight-bold mb-2">{{ $t("inviteAccept.title") }}</div>


          <v-alert v-if="!isAuthed" type="info" text dense class="mb-3">
            {{ $t("inviteAccept.loginHint") }}
          </v-alert>

          <div v-if="!isAuthed">
            <v-btn color="primary" block class="mt-3" @click="login">
              <v-icon left>mdi-google</v-icon>{{ $t("login.googleButton") }}
            </v-btn>

            <p class="legal-consent__text legal-consent__note">
              {{ $t("login.continueLegalNotice") }}
              <router-link to="/legal-notice">{{ $t("login.legalNotice") }}</router-link>
              {{ $t("login.continueLegalAnd") }}
              <router-link to="/privacy-policy">{{ $t("login.privacyPolicy") }}</router-link>.
            </p>
          </div>

          <div v-else>
            <div class="mb-3" style="opacity:.75">
              {{ $t("inviteAccept.joinHint") }}
            </div>
            <v-btn color="primary" block :loading="loading" @click="accept">
              {{ $t("inviteAccept.joinButton") }}
            </v-btn>
          </div>

          <v-alert v-if="error" type="error" dense text class="mt-3">
            {{ error }}
          </v-alert>
          <v-alert v-if="success" type="success" dense text class="mt-3">
            {{ $t("inviteAccept.success") }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { acceptInviteToken } from "../services/db";

export default {
  data: () => ({ loading: false, error: "", success: false }),
  computed: {
    ...mapGetters("auth", ["isAuthed", "uid"])
  },
  methods: {
    async login() {
      try {
        await this.$store.dispatch("auth/loginGoogle", {
          acceptedLegal: true
        });
      } catch (e) {
        this.error = e.message || this.$t("inviteAccept.loginError");
      }
    },
    async accept() {
      this.loading = true;
      this.error = "";
      try {
        const token = this.$route.params.token;
        await acceptInviteToken({ uid: this.uid, token });
        this.success = true;
        await this.$store.dispatch("groups/refresh");
        await this.$store.dispatch("events/refresh");
        setTimeout(() => this.$router.replace("/calendar"), 900);
      } catch (e) {
        this.error = e.message || this.$t("inviteAccept.acceptError");
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.legal-consent__text {
  color: #6d6578;
  font-size: 11px;
  line-height: 1.45;
}

.legal-consent__note {
  margin: 8px 0 0;
  text-align: center;
}

.legal-consent__text a {
  color: #6d28d9;
  font-weight: 700;
  text-decoration: none;
}

.legal-consent__text a:hover {
  text-decoration: underline;
}
</style>
